import * as React from "react";

import { IconCaretDown } from "@common/components/Atoms/Icons";

/*===========================================================================
  Button
/*======================================================================== */

interface ButtonProps {
    id: string;
    type?: "button" | "reset" | "submit" | undefined;
    block?: boolean;
    square?: boolean;
    small?: boolean;
    large?: boolean;
    green?: boolean;
    purple?: boolean;
    blue?: boolean;
    facebook?: boolean;
    linkedin?: boolean;
    disabled?: boolean;
    waiting?: boolean;
    dropdown?: boolean;
    className?: string;
    style?: object;
    dataCy?: string;
    onClick: (event: any) => void;
}

export const Button: React.SFC<ButtonProps> = props => {
    const classes = ["c-button"];
    if (props.block) classes.push("c-button--block");
    if (props.square) classes.push("c-button--square");
    if (props.small) classes.push("c-button--sm");
    if (props.large) classes.push("c-button--lg");
    if (props.green) classes.push("c-button--green");
    if (props.purple) classes.push("c-button--purple");
    if (props.blue) classes.push("c-button--blue");
    if (props.facebook) classes.push("c-button--facebook");
    if (props.linkedin) classes.push("c-button--linkedin");
    if (props.dropdown) classes.push("c-button--dropdown");
    if (props.disabled) classes.push("c-button--disabled");
    if (props.waiting) classes.push("c-button--waiting");
    if (props.className) classes.push(props.className);
    return (
        <button
            id={"button-" + props.id || "no-id"}
            className={classes.join(" ")}
            onClick={props.onClick}
            disabled={props.disabled}
            style={props.style}
            type={props.type}
            data-cy={props.dataCy}
        >
            {props.children}
            {props.dropdown && <IconCaretDown />}
        </button>
    );
};

Button.defaultProps = {
    type: "button",
};
